import { ApplicationConsumerInformation } from "./types/ApplicationConsumerInformation.interface"
import { UrlParams } from "./types/urlParams.interface"

export class ParametersHandler {
    parameters: ApplicationConsumerInformation

    constructor() {
        this.parameters = this.getApplicationConsumerInformation()
    }

    private getApplicationConsumerInformation(): ApplicationConsumerInformation {
        let urlParams = this.queryToObject(window.location.href)

        if (!urlParams.service) return {}

        urlParams = this.queryToObject(decodeURI(urlParams.service))

        if (!urlParams.redirect_uri) return {}
        if (urlParams.redirect_uri) {
            urlParams = this.queryToObject(decodeURI(urlParams.redirect_uri))
        }

        return urlParams
    }

    private queryToObject(uri: string) {
        try {
            const queryString = new URL(uri).search
            return this.getUrlParams(queryString)
        } catch {
            return {}
        }
    }

    private getUrlParams(
        url: string
    ): ApplicationConsumerInformation & UrlParams {
        return new Proxy(new URLSearchParams(url), {
            get: (searchParams, prop: string) => searchParams.get(prop)
        }) as URLSearchParams & ApplicationConsumerInformation & UrlParams
    }
}
